import i18next from 'i18next';
import { createModel } from '@rematch/core';
import _ from 'lodash';

import { RootModel } from '../index';
import { apiUrls, replaceUrls } from '../../api/apiUrls';
import { put } from '../../api/api';
import { timezones } from '../../utils/content';

const getDefaultTimeZone = () => {
  let fromTimezone = _.find(timezones, { value: Intl.DateTimeFormat().resolvedOptions().timeZone });

  if (!fromTimezone){
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.split('/');
    fromTimezone = _.find(timezones, (tz =>  tz.label.includes(timezone[1])));
  }

  return fromTimezone?.value || 'GMT';
};

export default createModel<RootModel>()({
  state: {
    languages: [{ value: 'en_GB', label: 'English' }],
    countries: [{ value: 'PT', text: 'Portugal' }],
    provinces: [{ value: '-', text: '-' }],
    selectedOddsType: 'decimal',
    selectedTimezone: getDefaultTimeZone(),
    selectedLanguage: 'en_GB'
  },

  reducers: {
    setOddsType(state, payload: string) {
      return { ...state, selectedOddsType: payload };
    },

    setLanguage(state, payload: string) {
      return { ...state, selectedLanguage: payload };
    },

    setTimezone(state, payload: string) {
      return { ...state, selectedTimezone: payload };
    },

    setLanguages(state, payload: { value: string, label: string }[]) {
      return { ...state, languages: payload };
    },

    setCountries(state, payload: { value: string, text: string }[]) {
      return { ...state, countries: payload };
    },

    setProvinces(state, payload: { value: string, text: string }[]) {
      return { ...state, provinces: payload.length > 0 ? payload : [{ value: '-', text: '-' }] };
    }
  },

  effects: (dispatch) => ({
    updateOddsType(value: string): void {
      dispatch.odds.setOddsType(value);
    },

    async updateLanguage(payload: string, state): Promise<void> {
      try {
        if (state.auth.authenticated) {
          await put(replaceUrls(apiUrls.updateLocale, { id: state.auth.customerId, locale: payload }));
        }
        i18next.changeLanguage(payload);
        localStorage.setItem('locale', payload);

        await dispatch.odds.setLanguage(payload);

        await dispatch.events.getSportEvents();
      } catch (error) {
        dispatch.toast.showToast({ type: 'error', message: 'Oops! Something went wrong.' });
      }
    },

    updateTimezone(value: string): void {
      dispatch.odds.setTimezone(value);
    }
  })
});
